/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import { DragOutlined, LoadingOutlined, CloseOutlined } from '@ant-design/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { DOMAIN } from '../../../../SellingRateCalendarPage/state/constants';
import { useInjectSaga } from '../../../../../utils/redux/injectSaga';
import { useInjectReducer } from '../../../../../utils/redux/injectReducer';
import reducer from '../../../../SellingRateCalendarPage/state/reducer';
import saga from '../../../../SellingRateCalendarPage/state/saga';
import { Header, HeaderContainer, DragContainer, ScrollableBodyTall } from '../../../../DashboardPage/GridComponents';
import messages from './messages';
import { statsService } from '../../../../../utils/api';
import Table from '../../../../../components/Table';
import { compact, isEmpty } from 'lodash';
import Tabs from 'components/Tabs';
import { Col, Row, Tag } from 'antd';
import Button from 'components/forms/Button';
import { makeColumnFilteringProps } from '../../shared';
import { useSelector } from 'react-redux';
import session from 'containers/App/session';
import { FEATURES } from 'utils/permissions';

const Alerts = ({ isDraggable, token, propertyUuids, individualPropertyID }) => {
    useInjectReducer({ key: DOMAIN, reducer });
    useInjectSaga({ key: DOMAIN, saga });
    const TABS = Object.freeze({
        SELLING_RATES: '0',
        DERIVED: '1',
        RRPL: '2',
        RRPL_DEFAULTS: '3',
    });
    const intl = useIntl();

    const canViewDerivedRooms = useSelector(session.selectors.selectAccessibleFeatures).includes(
        FEATURES.derivedRoomsConfigManagement,
    );

    const [fetching, setFetching] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [data, setData] = useState([]);
    const [fullData, setFullData] = useState([]);
    const [isFlipped, setIsFlipped] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState();
    const [selectedTab, setSelectedTab] = useState();
    const [tabs, setTabs] = useState([]);

    const handleFlip = async (record) => {
        if (!isFlipped) {
            setSelectedProperty(record);
        }
        setIsFlipped(!isFlipped);
    };

    const dragContainer = isDraggable && (
        <DragContainer className="draggable-item">
            <DragOutlined />
        </DragContainer>
    );

    const processFullData = () => {
        let rawData = !isEmpty(fullData) ? [...fullData] : [];
        if (!isEmpty(propertyUuids)) {
            rawData = rawData.filter(({ uuid }) => propertyUuids.includes(uuid));
        }
        rawData = rawData.filter(
            (a) =>
                a.missingSellingRates.length > 0 ||
                a.missingDerived.length > 0 ||
                Object.keys(a.missingPriceLimits).length > 0 ||
                a.missingPriceLimitsDefaults.length > 0,
        );
        setData(rawData);
    };

    const loadData = async () => {
        setFetching(true);
        setFetched(false);
        let response = {};
        if (individualPropertyID) {
            response = await statsService({
                token,
            }).getAccountManagementAlerts({ propertyID: individualPropertyID });
        } else {
            response = await statsService({
                token,
            }).getAccountManagementAlerts();
        }
        setFullData(Object.values(response?.data));
        setFetching(false);
        setFetched(true);
    };

    const renderFlag = (val) => (val === 0 ? <></> : <CloseOutlined style={{ color: '#ff4d4f' }} />);

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        processFullData();
    }, [propertyUuids, fullData]);

    useEffect(() => {
        if (selectedProperty) {
            const tempTabs = [];
            if (selectedProperty?.missingSellingRates?.length > 0) {
                tempTabs.push({
                    label: 'Selling Rates',
                    key: TABS.SELLING_RATES,
                    children: (
                        <>
                            <h4>{intl.formatMessage(messages.sellingRateText)}</h4>
                            {selectedProperty?.missingSellingRates.map((d) => (
                                <Tag>{d}</Tag>
                            ))}
                        </>
                    ),
                });
            }
            if (selectedProperty?.missingDerived?.length > 0 && canViewDerivedRooms) {
                tempTabs.push({
                    label: 'Derived',
                    key: TABS.DERIVED,
                    children: (
                        <>
                            <h4>{intl.formatMessage(messages.derivedText)}</h4>
                            {selectedProperty?.missingDerived.map((d) => (
                                <Tag>{d}</Tag>
                            ))}
                        </>
                    ),
                });
            }
            if (Object.values(selectedProperty?.missingPriceLimits).length) {
                tempTabs.push({
                    label: 'Hurdle/Rack Rates',
                    key: TABS.RRPL,
                    children: (
                        <>
                            <h4>{intl.formatMessage(messages.rrplText)}</h4>
                            {Object.entries(selectedProperty?.missingPriceLimits).map(([key, value]) => (
                                <>
                                    <h3>{key}</h3>
                                    <span>
                                        {value.map((d) => (
                                            <Tag>{d}</Tag>
                                        ))}
                                    </span>
                                </>
                            ))}
                        </>
                    ),
                });
            }
            if (selectedProperty?.missingPriceLimitsDefaults?.length > 0) {
                tempTabs.push({
                    label: 'Hurdle/Rack Defaults',
                    key: TABS.RRPL_DEFAULTS,
                    children: (
                        <>
                            <h4>{intl.formatMessage(messages.rrplDefaultText)}</h4>
                            {selectedProperty?.missingPriceLimitsDefaults.map((d) => (
                                <Tag>{d}</Tag>
                            ))}
                        </>
                    ),
                });
            }
            setTabs([...tempTabs]);
            if (selectedProperty.missingSellingRates.length > 0) {
                setSelectedTab(TABS.SELLING_RATES);
            } else if (
                selectedProperty.missingSellingRates.length < 1 &&
                selectedProperty.missingDerived.length > 0 &&
                canViewDerivedRooms
            ) {
                setSelectedTab(TABS.DERIVED);
            } else if (
                selectedProperty.missingSellingRates.length < 1 &&
                selectedProperty.missingDerived.length < 1 &&
                Object.values(selectedProperty?.missingPriceLimits).length > 0
            ) {
                setSelectedTab(TABS.RRPL);
            } else if (selectedProperty.missingPriceLimitsDefaults.length > 0) {
                setSelectedTab(TABS.RRPL_DEFAULTS);
            }
        } else {
            setTabs([]);
            setSelectedTab();
        }
    }, [selectedProperty]);

    const columns = compact([
        {
            title: intl.formatMessage(messages.name),
            dataIndex: 'name',
            align: 'left',
            width: '200px',
            sorter: (a, b) => a.name.localeCompare(b.name),
            defaultSortOrder: 'ascend',
            fixed: 'left',
            ...makeColumnFilteringProps(data, 'name'),
        },
        {
            title: intl.formatMessage(messages.sellingRates),
            dataIndex: 'missingSellingRates',
            align: 'center',
            width: '150px',
            render: (val) => renderFlag(val.length),
            sorter: (a, b) => a.missingSellingRates.length - b.missingSellingRates.length,
        },
        ...(canViewDerivedRooms
            ? [
                  {
                      title: intl.formatMessage(messages.derived),
                      dataIndex: 'missingDerived',
                      align: 'center',
                      width: '150px',
                      render: (val) => renderFlag(val.length),
                      sorter: (a, b) => a.missingDerived.length - b.missingDerived.length,
                  },
              ]
            : []),
        {
            title: intl.formatMessage(messages.roomRatePriceLimits),
            dataIndex: 'missingPriceLimits',
            align: 'center',
            width: '150px',
            render: (val) => renderFlag(Object.keys(val).length),
            sorter: (a, b) => Object.keys(a.missingPriceLimits).length - Object.keys(b.missingPriceLimits).length,
        },
        {
            title: intl.formatMessage(messages.roomRatePriceLimitsDefault),
            dataIndex: 'missingPriceLimitsDefaults',
            align: 'center',
            width: '150px',
            render: (val) => renderFlag(val.length),
            sorter: (a, b) => a.missingPriceLimitsDefaults.length - b.missingPriceLimitsDefaults.length,
        },
    ]);

    return (
        <>
            <HeaderContainer>
                <Header>{intl.formatMessage(messages.title)}</Header>
                {dragContainer}
            </HeaderContainer>
            <ScrollableBodyTall>
                {fetching && <LoadingOutlined style={{ marginRight: '8px' }} />}
                {!fetching && fetched && (
                    <>
                        {!isFlipped && (
                            <div>
                                <FormattedMessage
                                    {...(individualPropertyID
                                        ? messages.descriptionIndividualProperty
                                        : messages.description)}
                                />
                                <Table
                                    dataSource={data}
                                    columns={columns}
                                    pagination={{
                                        pageSize: 31,
                                        hideOnSinglePage: true,
                                    }}
                                    rowKey="name"
                                    tableLayout="auto"
                                    size="small"
                                    onRow={(record) => ({
                                        onClick: () => {
                                            handleFlip(record);
                                        },
                                    })}
                                    scroll={{ y: 360 }}
                                />
                            </div>
                        )}
                        {isFlipped && (
                            <div>
                                <Row>
                                    <Col span="5">
                                        <Button
                                            type="primary"
                                            onClick={() => setIsFlipped(!isFlipped)}
                                            style={{ marginTop: '5px' }}
                                        >
                                            <FormattedMessage {...messages.backToList}></FormattedMessage>
                                        </Button>
                                    </Col>
                                    <Col span="15">
                                        <h3>{selectedProperty?.name} </h3>
                                    </Col>
                                </Row>
                                {tabs.length > 0 && (
                                    <Tabs
                                        style={{ height: '260px' }}
                                        // activeKey={selectedTab}
                                        defaultActiveKey={selectedTab}
                                        // onChangeTab={changetab}
                                        items={tabs}
                                    />
                                )}
                            </div>
                        )}
                    </>
                )}
            </ScrollableBodyTall>
        </>
    );
};

export default Alerts;
